import { Component, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ApiserviceService } from "../../../apiservice.service";
import { Subscription } from "rxjs";

/**
*
* <strong>List of API using</strong>
* <ol>
* <li>estapi_attribute_datatypes_get</li>
* </ol>
*
*/

@Component({
    selector: 'info-dialog',
    templateUrl: './info-dialog.component.html',
    styleUrls: ['./info-dialog.component.css']
  })
  
  export class InfoDialog implements OnDestroy {
    dataTypesList: any = [];
    loader: boolean = false;
    private subs = new Subscription();
    constructor(public dialogRef: MatDialogRef<InfoDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any, private readonly api: ApiserviceService) {
      this.getDataTypes();
    }
  
    getDataTypes() {
      this.loader = true;
      const dataTypeSub = this.api.getEmsData("/attribute/datatypes").subscribe({
        next: (data) => {
          this.dataTypesList = data;
          this.loader = false;
        },
        error: () => {
          this.loader = false;
        },
      });
      this.subs.add(dataTypeSub);
    }

    ngOnDestroy(): void {
      this.subs.unsubscribe();
    }
  }
  